import type { ReactNode } from 'react';
import { ProgressRing } from '../ui/ProgressRing';
import { GridMatrix } from './GridMatrix';
import { MonthCell } from './MonthCell';
import { AdvanceBalanceCard } from './AdvanceBalanceCard';
import { MonthDetailModal } from './MonthDetailModal';
import './installments.css';

/**
 * W06 §4 — compound component surface for the 120-month installment grid:
 *
 *   <InstallmentGrid.Root>
 *     <InstallmentGrid.ProgressRing … />
 *     <InstallmentGrid.AdvanceCard … />
 *     <InstallmentGrid.Matrix … onSelect={…} />
 *     <InstallmentGrid.Modal slot={…} onClose={…} />
 *   </InstallmentGrid.Root>
 */
function InstallmentGridRoot({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <div className={`installment-grid${className ? ` ${className}` : ''}`} data-testid="installment-grid">
      {children}
    </div>
  );
}

export const InstallmentGrid = {
  Root: InstallmentGridRoot,
  ProgressRing,
  Matrix: GridMatrix,
  Cell: MonthCell,
  AdvanceCard: AdvanceBalanceCard,
  Modal: MonthDetailModal,
};

export default InstallmentGrid;
